import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

export const findAll = (mid) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors`, { headers: authHeader() })
}

export const findVisitors = (mid, params) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors`, { params: params, headers: authHeader() });
}

export const create = (mid, user) => {
  return http.post(API_URL + `/merchants/${mid}/v1/visitors`, user, { headers: authHeader() });
}

export const update = (mid, id, user) => {
  return http.put(API_URL + `/merchants/${mid}/v1/visitors/${id}`, user, { headers: authHeader() });
}

export const findById = (mid, id) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors/${id}`, { headers: authHeader() });
}

export const deleteVisitor = (mid, id) => {
  return http.delete(API_URL + `/merchants/${mid}/v1/visitors/${id}`, { headers: authHeader() });
}

export const sendEmail = (mid, id, data) => {
  return http.post(API_URL + `/merchants/${mid}/v1/visitors/${id}/email`, data, { headers: authHeader() });
}

export const sendEmails = (mid, data) => {
  return http.post(API_URL + `/merchants/${mid}/v1/visitors/email`, data, { headers: authHeader() });
}

export const report = (mid) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors/report`, { headers: authHeader() })
}

export const associate = (mid, visitorId, customerId) => {
  return http.put(API_URL + `/merchants/${mid}/v1/visitors/${visitorId}/customers/${customerId}/associate`, null, { headers: authHeader() });
}

export const deAssociate = (mid, visitorId, customerId) => {
  return http.put(API_URL + `/merchants/${mid}/v1/visitors/${visitorId}/customers/${customerId}/de-associate`, null, { headers: authHeader() });
}

export const findCustomers = (mid, visitorId, page, size) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors/${visitorId}/customers?page=${page}&size=${size}`, { headers: authHeader() })
}

export const findByVendorId = (mid, params) => {
  return http.get(API_URL + `/merchants/${mid}/v1/visitors`, { params, headers: authHeader()})
}

export const handleResponse = (response) => {
  return response
}



// WEBPACK FOOTER //
// ./src/service/visitor.service.js